/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Canvas_Refusal_UnavailableInputs */



/**
* | output |
* | --- |
* | "This app can no longer reach its data through this link. Nothing you do here will change that — ask whoever shared it with you." |
*
* @param {Canvas_Refusal_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_refusal_unavailable = /** @type {((inputs?: Canvas_Refusal_UnavailableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Refusal_UnavailableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diese App erreicht über diesen Link keine Daten mehr. Daran lässt sich hier nichts ändern — bitte wenden Sie sich an die Person, die den Link geteilt hat.")
	return /** @type {LocalizedString} */ ("This app can no longer reach its data through this link. Nothing you do here will change that — ask whoever shared it with you.")
});